import axios from 'axios'
import config from '../config'
import { getUserToken } from "../utils"

const getEmployeeDropdownApi = async(params) => {
    const response = await axios({
        url: `${config.api.base_url}institute/get-bdm-dropdown-list?${params}`,
        method: "get",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getUserToken()}`
        }
    })
    return response

}

export default getEmployeeDropdownApi